export const settings = {
  //#region API URL
  // Localhost
  // checkAuthApiUrl: "https://localhost:44343/Api/AuthCheck",
  // apiUrl: "https://localhost:44343/Api/Proxy/",

  // UAT
  // checkAuthApiUrl: "https://uatgateway.teamstar.com.my/Api/AuthCheck",
  // apiUrl: "https://uatgateway.teamstar.com.my/Api/Proxy/",

  // Prod
  checkAuthApiUrl: "https://gateway.teamstar.com.my/Api/AuthCheck",
  apiUrl: "https://gateway.teamstar.com.my/Api/Proxy/",
  //#endregion

  // To Encrypt the data that will be sent to the server
  encryptKey: "V5AUALHfPunfJLKA",

  //#region Static URL

  staticSEOJsonUrl: "/files/seo/seo-static.json",
  storeLocationsJsonUrl: "/files/storeLocations.json",

  homePageCarouselImageFolder: "/images/homepagecarousel/",
  productImageFolder: "/images/products/",
  productMoreInfoImageFolder: "/images/products/moreinfo/",
  promoImageFolder: "/images/promo/",
  categoryImageFolder: "/images/category/",
  catalogsImageFolder: "/images/catalogs/",

  filesFolder: "/files/",
  catalogsFileFolder: "/files/catalogs/",
  //#endregion

  //#region API URL
  user: {
    register: "User/Register",
    requestOTP: "User/RequestOTP",
    login: "User/Login",
    logout: "User/Logout",
    getProfileDetails: "User/GetProfileDetails",
    requestQuotation: "User/RequestQuotation",
  },

  jwt: {
    generateJWTToken: "Jwt/GenerateJWTToken",
  },

  publicData: {
    getProducts: "PublicData/GetProducts",
    getProductById: "PublicData/GetProductById",
    getRandomProducts: "PublicData/GetRandomProducts",
    checkProductAvailability: "PublicData/CheckProductAvailability",
    requestQuotation: "PublicData/RequestQuotation",

    getFeaturedCategory: "PublicData/GetFeaturedCategory",
    getCategories: "PublicData/GetCategories",
    getSubCategories: "PublicData/GetSubCategories",
    getCombinedCategories: "PublicData/GetCombinedCategories",

    newsletterSub: "PublicData/NewsletterSub",

    contactUs: "PublicData/ContactUs",

    getPromotions: "PublicData/GetPromotions",
    getPromotionDetails: "PublicData/GetPromotionDetails",

    getCatalogs: "PublicData/GetCatalogs",
  },
  //#endregion
};
